import React from 'react'
import { Box } from '@mui/material'
import { useTranslation } from '../shared/hooks/useIntractionTranslate'
import { INTERAX_COLORS } from '../constants/interaxColors'

const NEW_SOFT_BG = 'rgba(16, 185, 129, 0.08)'
const NEW_BORDER = 'rgba(16, 185, 129, 0.3)'
const NEW_DOT_SIZE_PX = 8

/** A steady green "New" pill beside a sidebar item whose page holds something not read yet. */
export const NewBadge: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 1,
        px: 1,
        py: 0.25,
        borderRadius: '100px',
        backgroundColor: NEW_SOFT_BG,
        border: `1px solid ${NEW_BORDER}`,
        flexShrink: 0
      }}
    >
      <Box
        sx={{
          width: NEW_DOT_SIZE_PX,
          height: NEW_DOT_SIZE_PX,
          borderRadius: '50%',
          backgroundColor: INTERAX_COLORS.green
        }}
      />
      <Box
        component="span"
        sx={{
          fontSize: '0.65rem',
          fontWeight: 800,
          letterSpacing: '0.05em',
          color: INTERAX_COLORS.green
        }}
      >
        {t('common.new')}
      </Box>
    </Box>
  )
}
